import { FactorService } from "../_services/api/sales/factor.service";

export const screenFactors = {
  namespaced: true,
  state: {
    factors: [],
  },
  actions: {
    async getFactors({ commit }, factors) {
      return FactorService.getFactors(factors).then((res) => {
        commit("setFactors", res.data.value);
      });
    },
  },
  mutations: {
    setFactors(state, factors) {
      state.factors = factors;
    },
  },
  getters: {
    getFactors(state) {
      return state.factors;
    },
    getFactorByCode: (state) => (code) => {
      // eslint-disable-next-line no-console
      // this.$logger.debug("calling getFactorByCode getter:", state.factors, code);
      return state.factors.find((i) => i.Code == code);
    },
  },
};
